import React, {useState} from 'react';
import { StaffList } from './staffList';
import { Modal, Button, DropdownItem } from 'react-bootstrap';

export function ViewSchoolStaffModal ( {linkStyle, schoolId} ) {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    if (!schoolId) {
        return null;
    }

    return (
        <>

            {linkStyle === "button" ? (<Button size="sm" variant="outline-primary" className="w-100 mt-3" onClick={handleShow}>
        View School Staff
        </Button>) : linkStyle === "dropdownItem" ? (
            <DropdownItem onClick={handleShow}>View School Staff</DropdownItem>
        ) :
        (<Button variant="link" onClick={handleShow}>
            View School Staff
            </Button>)
        }

        <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
            <StaffList schoolId={schoolId} />
        </Modal.Body>
      </Modal>
        </>
    )
};